/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core';
import React from 'react';
import GenericSkeleton from '../../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        border: '1px solid #D9D9D9',
        borderRadius: '8px',
        padding: '20px',
        marginTop: '24px',
        '& hr': {
            margin: '8px 0 19px',
            border: '1px solid rgba(0, 0, 0, 0.05)',
        },
        '@media screen and (max-width: 1024px)': {
            flexDirection: 'column',
        },
    },
    leftContainer: {
        maxWidth: '315px',
        width: '100%',
        marginRight: '20px',
        '& > div:nth-child(2)': {
            width: '100%',
        },
        '@media screen and (max-width: 1024px)': {
            marginRight: '0',
            display: 'flex',
            maxWidth: '100%',
        },
        '@media screen and (max-width: 420px)': {
            flexDirection: 'column',
        },
    },
    rightContainer: {
        width: '100%',
    },
    image: {
        marginTop: 0,
        marginBottom: '30px',
        aspectRatio: '1/1.5',
        '@media screen and (max-width: 1024px)': {
            marginBottom: '20px',
            maxWidth: '315px',
            width: '100%',
            marginRight: '20px',
        },
        '@media screen and (max-width: 768px)': {
            height: '300px !important',
        },
        '@media screen and (max-width: 580px)': {
            height: '250px !important',
        },
        '@media screen and (max-width: 420px)': {
            height: '300px !important',
            marginLeft: 0,
        },
    },
    btnContainer: {
        display: 'flex',
        '& > div:nth-child(1)': {
            marginRight: '20px',
        },
        '@media screen and (max-width: 420px)': {
            flexDirection: 'column',
        },
    },
    button: {
        maxWidth: '220px',
        marginLeft: 0,
        marginTop: 0,
    },
    heading: {
        maxWidth: '250px',
        marginLeft: 0,
        marginTop: 0,
    },
    subHeading: {
        maxWidth: '150px',
        marginLeft: 0,
        marginTop: 0,
    },
    desc: {
        maxWidth: '450px',
        marginLeft: 0,
        marginTop: 0,
    },
});

const LoadingSkeleton = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.leftContainer}>
                <GenericSkeleton height="370px" width="100%" className={classes.image} />
                <div>
                    <GenericSkeleton height="20px" width="100%" className={classes.heading} />
                    <br />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                    <br />
                    <GenericSkeleton height="55px" width="100%" />
                </div>
            </div>
            <div className={classes.rightContainer}>
                <section>
                    <GenericSkeleton height="20px" width="100%" className={classes.heading} />
                    <br />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                    <div className={classes.btnContainer}>
                        <GenericSkeleton height="35px" width="100%" className={classes.button} />
                        <GenericSkeleton height="35px" width="100%" className={classes.button} />
                    </div>
                </section>
                <hr />
                <section>
                    <GenericSkeleton height="20px" width="100%" className={classes.heading} />
                    <br />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                </section>
                <hr />
                <section>
                    <GenericSkeleton height="20px" width="100%" className={classes.heading} />
                    <br />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                </section>
                <hr />
                <section>
                    <GenericSkeleton height="20px" width="100%" className={classes.heading} />
                    <br />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                </section>
                <hr />
                <section>
                    <GenericSkeleton height="20px" width="100%" className={classes.heading} />
                    <br />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                    <GenericSkeleton height="35px" width="100%" className={classes.button} />
                    <GenericSkeleton height="20px" width="100%" className={classes.subHeading} />
                    <GenericSkeleton height="35px" width="100%" className={classes.button} />
                    <br />
                    <GenericSkeleton height="20px" width="100%" className={classes.desc} />
                </section>
            </div>
        </div>
    );
};

export default LoadingSkeleton;
